<template>
  <basic-info-lottie-banner>
    <p class="basicInfoIdle__hint">{{ hint }}</p>
  </basic-info-lottie-banner>
</template>

<script>
import BasicInfoLottieBanner from './BasicInfoLottieBanner.vue'

export default {
  name: 'BasicInfoIdleAnim',
  components: { BasicInfoLottieBanner },
  props: {
    hint: {
      type: String,
      default: '填好名称就可以继续啦',
    },
  },
}
</script>

<style scoped>
.basicInfoIdle__hint {
  margin: 0;
  text-align: center;
  font-size: var(--link-text-sm, 13px);
  font-weight: var(--link-font-medium, 500);
  color: var(--link-ink-secondary, #4a4541);
  line-height: 1.55;
}
</style>
